import React, { Component } from "react";
import { formatoSeparadorMiles, formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'
import ReactTooltip from "react-tooltip";
import $ from "jquery";

export default class InputText extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            size: props.size,
            title: props.title,
            hidden: props.hidden,
            editable: props.editable,
            type: props.type,
            label: props.label,
            minValue: props.minValue,
            maxValue: props.maxValue,
            minLength: props.minLength,
            maxLenght: props.maxLenght,
            required: props.required,
            nullable: props.nullable,
            debitable: props.debitable,
            format: props.format,
            value: undefined
        }

    };


    componentDidMount() {

    }
    handleKey =(e) =>{
        $('#idPronetPaso1').on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) { 
              e.preventDefault();
              return false;
            }
        });
        
    };

    handleChange = (e) => {
        //console.log("cambio")
       // console.log(e.target.value)
       $('#idPronetPaso1').on('keyup keypress', function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) { 
          e.preventDefault();
          return false;
        }
      });
        if (this.props.required && e.target.value === null) {
            this.props.inputValue(e.target.value, this.props.name, true, "El campo " + this.props.name + " es requerido",this.props.format, this.props.label, this.props.required, this.props.minLength);
            return;
        }
        this.props.inputValue(e.target.value, this.props.name, false, "", this.props.format, this.props.label, this.props.required, this.props.minLength);
    };

    verificarTipo() {
        
        var tipo = "text"
        if (this.props.format === "INTEGER" || this.props.format === "LONG")
            return (<input type="number" className="form-control input-box" name={this.props.name} size={this.props.size} required={this.props.required}
                placeholder={this.props.label} minlength={this.props.minLength} maxlength={this.props.maxLength} defaultValue={this.props.value}
                onChange={(e) => { this.handleChange(e) }} style={{textTransform: "lowercase"}}/>)

        if (this.props.format === "MONEY")
            return (<input type="text" className="form-control input-box" name={this.props.name} size={this.props.size} required={this.props.required}
                placeholder={this.props.label}  defaultValue={formatoSeparadorMilesValue(this.props.value)} onKeyUp= {formatoSeparadorMiles}
                onChange={(e) => { this.handleChange(e) }} style={{textTransform: "lowercase"}}/>)
        else

            return (<input type="text" className="form-control input-box" name={this.props.name} size={this.props.size} required={this.props.required}
                placeholder={this.props.label} minlength={this.props.minLength} maxlength={this.props.maxLength} defaultValue={this.props.value}
                onChange={(e) => { this.handleChange(e) }} style={{textTransform: "lowercase"}}/>)



    }



    render() {


        return (
            <div className="form-group">
                <label className="input-label" data-tip={this.props.title} >
                    <i className="fas fa-question-circle" style={{fontSize:"25px",color:"#9c9c9c"}}></i> {this.props.label}
                </label>
                {this.verificarTipo()}
                <ReactTooltip/>
            </div>
        )

    }
}